import { createRoutine } from 'redux-saga-routines';

const ARTICLES_ACTION_PREFIX = 'ARTICLES';
const FETCH_FEATURED_ARTICLES_PREFIX = 'FETCH_FEATURED_ARTICLES';

const articlesAction = createRoutine(ARTICLES_ACTION_PREFIX);
const featuredArticlesAction = createRoutine(FETCH_FEATURED_ARTICLES_PREFIX);

export { articlesAction, featuredArticlesAction };
